import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../layout/header";
import axios from "axios";
import Footer from "../layout/footer";

const bg = require("../../images/contactus.png");

class Contact2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      contactNumber: "",
      message: ""
    };
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, contactNumber, message } = this.state;

    axios
      .post(
        "https://emailbackend.infinitycs.com.au/api/v1/contactus/kangaroo-shine/contactus",
        {
          name,
          email,
          contactNumber,
          message
        }
      )
      .then((response) => {
        console.log("Data submitted successfully:", response.data);
        alert("Your message has been sent!");
      })
      .catch((error) => {
        console.error("There was an error sending the data:", error);
        alert("Failed to send your message. Please try again.");
      });
  };

  render() {
    return (
      <>
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">Contact Us </h1>
                <div className="breadcrumb-row"></div>
              </div>
            </div>
          </div>

          <div className="section-full content-inner contact-page-8 bg-white">
            <div className="container">
              <div className="row">
              <div className="col-lg-4 col-md-12 ">
                  <div className="row">
                    <div className="col-lg-12 col-md-12 m-b30">
                      <div className="icon-bx-wraper bx-style-1 p-a20 radius-sm">
                        <div className="icon-content">
                          <h5 className="dlab-tilte">
                            <span className="icon-sm text-primary">
                              <i className="ti-location-pin"></i>
                            </span>
                            Company Address
                          </h5>
                          <p>6308 31 Bourton Road Merrimac 4226</p>
                          <h5 className="dlab-tilte">
                            <span className="icon-sm text-primary">
                              <i className="ti-location-pin"></i>
                            </span>
                            Service Areas
                          </h5>
                          <p>Proudly serving Gold Coast QLD</p>
                          <h6 className="m-b15 font-weight-400">
                            <i className="ti-alarm-clock"></i> Business Hours
                          </h6>
                          <p className="m-b0">
                            Monday – Friday: 8:00 am – 6:00 pm
                          </p>
                          <p className="m-b0">Saturday: 9:00 am – 5:00 pm</p>
                          <p>Sunday - Closed</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-6 m-b30">
                      <div className="icon-bx-wraper bx-style-1 p-a20 radius-sm">
                        <div className="icon-content">
                          <h5 className="dlab-tilte">
                            <span className="icon-sm text-primary">
                              <i className="ti-email"></i>
                            </span>
                            E-mail
                          </h5>
                          <p className="m-b0">info@kangarooshine.com.au</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-6 m-b30">
                      <div className="icon-bx-wraper bx-style-1 p-a20 radius-sm">
                        <div className="icon-content">
                          <h5 className="dlab-tilte">
                            <span className="icon-sm text-primary">
                              <i className="ti-mobile"></i>
                            </span>
                            Phone Numbers
                          </h5>
                          <p className="m-b0">0424 888 804</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-8 col-md-12 m-b30">
                  <form
                    className="inquiry-form wow bg-white fadeInUp"
                    data-wow-delay="0.2s"
                    onSubmit={this.handleSubmit}
                  >
                     <h2 className="title-new">
                     Get in Touch with Kangaroo Shine Property Services
                </h2>
                    {/* <h3 className="title-box font-weight-300 m-t0 m-b10">
                      Get in Touch with Kangaroo Shine Property Services
                      <span className="bg-primary"></span>
                    </h3> */}
                    <p>
                      Whether you’re looking for regular cleaning, a one-time
                      deep clean, or specialized services, Kangaroo Shine
                      Property Services is here to help. We’d love to discuss
                      your needs and create a custom cleaning plan that keeps
                      your space spotless and inviting.
                    </p>
                    <div className="row">
                      <div className="col-lg-12 col-md-12">
                        <div className="form-group">
                          <div className="input-group">
                            <span className="input-group-addon">
                              <i className="ti-user text-primary"></i>
                            </span>
                            <input
                              name="name"
                              type="text"
                              required
                              className="form-control"
                              placeholder="Name"
                              value={this.state.name}
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12">
                        <div className="form-group">
                          <div className="input-group">
                            <span className="input-group-addon">
                              <i className="ti-mobile text-primary"></i>
                            </span>
                            <input
                              name="contactNumber"
                              type="text"
                              required
                              className="form-control"
                              placeholder="Contact Number"
                              value={this.state.contactNumber}
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12">
                        <div className="form-group">
                          <div className="input-group">
                            <span className="input-group-addon">
                              <i className="ti-email text-primary"></i>
                            </span>
                            <input
                              name="email"
                              type="email"
                              className="form-control"
                              required
                              placeholder="Your Email"
                              value={this.state.email}
                              onChange={this.handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12">
                        <div className="form-group">
                          <div className="input-group">
                            <span className="input-group-addon">
                              <i className="ti-agenda text-primary"></i>
                            </span>
                            <textarea
                              name="message"
                              rows="4"
                              className="form-control"
                              required
                              placeholder="Message"
                              value={this.state.message}
                              onChange={this.handleChange}
                            ></textarea>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12 col-md-12">
                        <button
                          name="submit"
                          type="submit"
                          value="Submit"
                          className="site-button button-md"
                        >
                          <span>Submit</span>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}
export default Contact2;
